import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { ConfigurationProvider } from './contexts/ConfigurationContext'
import Layout from './components/Layout'
import Home from './pages/Home'
import Configurations from './pages/Configurations'

function App() {
  return (
    <ConfigurationProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/configurations" element={<Configurations />} />
        </Routes>
      </Layout>
    </ConfigurationProvider>
  )
}

export default App 